import { useEffect, useState } from "react";
import { getImageFromDB, storeImageInDB } from "../../../utils/indexdb.utils"; 
import "./styles.css";
import CountdownTimer from "../../shared/CountDownTimer/CountdownTimer";

interface CountdownTimerProps {
  timeInMilliseconds?: number;
  jackpot: number;
}

const LOGO_KEY = "pegamas-logo";
const LOGO_URL = "https://lotteryblob.blob.core.windows.net/lottery-files/pegamas-logo.png";

const Header = ({ timeInMilliseconds, jackpot }: CountdownTimerProps) => {
  const [logoSrc, setLogoSrc] = useState<string | null>(null);

  useEffect(() => {
    const fetchAndCacheLogo = async () => {
      try {
        const cachedLogo = await getImageFromDB(LOGO_KEY);

        if (cachedLogo) {
          setLogoSrc(URL.createObjectURL(cachedLogo));
        } else {
          const response = await fetch(LOGO_URL);
          const blob = await response.blob();

          await storeImageInDB(LOGO_KEY, blob);
          setLogoSrc(URL.createObjectURL(blob));
        }
      } catch (error) {
        setLogoSrc(LOGO_URL); 
      }
    };

    fetchAndCacheLogo();
  }, []);

  return (
    <div className="d-flex justify-content-between align-items-center header w-100">
      <CountdownTimer timeInMilliseconds={timeInMilliseconds} />
      <div className="accumulated">
        <p className="amount mb-0">ACUMULADO</p>
        <h1 className="fw-bold">RD${jackpot.toLocaleString()}</h1>
      </div>

      <div className="accumulated">
        {logoSrc ? (
          <img
            style={{ height: "8.7rem", width: "auto" }}
            src={logoSrc}
            alt="PegaMás Logo"
          />
        ) : (
          <p>Cargando logo...</p>
        )}
      </div>
    </div>
  );
};

export default Header;
